import React, { ReactNode, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Company } from 'store/authSlice'; // Import your Company type

interface ProtectedRouteProps {
  children: ReactNode;
}

interface UserData {
  isLoggedIn: boolean;
  loginTime?: number;
  expiresAt?: number;
  email: string;
  name: string;
  role: string;
  companyId: string | null;
  companies?: Company[]; // Use proper Company type
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    const validateAuth = () => {
      try {
        const userData = sessionStorage.getItem('user');

        if (!userData) {
          setIsAuthenticated(false);
          return;
        }

        const user: UserData = JSON.parse(userData);

        // Check if user data has required properties
        if (!user || typeof user !== 'object' || !user.isLoggedIn) {
          setIsAuthenticated(false);
          return;
        }

        // Check session expiration if exists
        if (user.expiresAt && Date.now() > user.expiresAt) {
          sessionStorage.removeItem('user');
          setIsAuthenticated(false);
          return;
        }

        // ✅ FIXED: Allow companyId to be null (for super admin)
        // Basic validation of required fields
        if (!user.email || !user.role) {
          // Removed companyId requirement
          setIsAuthenticated(false);
          return;
        }

        setIsAuthenticated(true);
      } catch (error) {
        // If JSON parsing fails or any error occurs

        sessionStorage.removeItem('user');
        setIsAuthenticated(false);
      }
    };

    validateAuth();
  }, []);

  // Show loading state while checking authentication
  if (isAuthenticated === null) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: '100vh' }}
      >
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
